//@ts-nocheck
import {
  Avtaar,
  Box,
  BoxProps,
  ColorOptions,
  Icon,
  Image,
  ImageProps,
  ModalTypes,
  SearchBar,
  Spacer,
  Text,
} from '@jfs/ui-new'
import { isIE } from '@jfs/ui-new/src/utils/utils'
import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import * as React from 'react'
import { Platform, ScrollView } from 'react-native'
import { CustomRecyclerView } from '../../comps/CustomRecyclerView'
import { Modal } from '../../comps/Modal'
import { useStores } from '../../data/store'
import { convertHexToRGBA } from '../../utils'
import { EMI } from '../../utils/constants'

export interface DropDownData {
  text?: string
  imageUrl?: string
  id?: string
}

export interface DropdownProps {
  ID?: string
  error?: string
  type?: string
  isNewPG?: boolean
  editable?: boolean
  data: Array<DropDownData>
  onChange?: (value: string) => void
  touched?: boolean
  value?: string
  label?: string
  showLabel?: boolean
  placeHolder?: string
  isModalSizeFixed?: boolean
  modalPosition?: keyof typeof ModalTypes
  getSelectedItemData?: (value: any) => void
  newSheet?: boolean
  setSelectedItem: any
  onClose: () => void
}

export interface RefCalback {
  isEditable(): boolean
  focus(): void
}

const MIN_DATA_TO_SHOW = 10

const getImage = (item: any) => {
  if (item?.imageUrl) {
    return <Avtaar hide={!item?.imageUrl} source={item?.imageUrl ?? ''} type="medium" title={item?.text ?? ''} />
  } else {
    return <Image {...styles.imageView} source={require('../../assets/images/bank.png')} />
  }
}

const ListItem = ({
  item,
  onPress,
  index,
  selectedItem,
  theme,
}: {
  item: DropDownData
  onPress: (item: DropDownData) => void
  index: number
  selectedItem: any
  theme: any
}) => {
  const handlePress = () => onPress(item)
  const title = item?.text ?? ''

  return (
    <Box height={64}>
      <Box
        {...styles.container}
        onPress={handlePress}
        underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
        borderBottomColor={'SEPERATOR'}
        f={1}
        testID={`dropdownListItemId${index}`}>
        <>
          <Box f={1} alignItems="center" flexDirection={'row'}>
            {getImage(item)}
            <Box padding={16} flexShrink={1}>
              <Text
                fontFamily="jioType-medium"
                fontSize={12}
                color={selectedItem ? (theme?.brandColor as ColorOptions) : (theme?.bodyTextColor as ColorOptions)}>
                {title}
              </Text>
            </Box>
          </Box>
          {selectedItem && <Icon id="ROUND_TICK" color={theme?.brandColor as ColorOptions} size={24} />}
        </>
      </Box>
      <Box {...styles.separatorStyle(theme)} />
    </Box>
  )
}

const ScrollWrapperIE = ({ children }: any) => {
  return (
    <>
      {isIE() && <ScrollView style={{ flex: 1, height: '100%' }}>{children}</ScrollView>}
      {!isIE() && <>{children}</>}
    </>
  )
}

export const Dropdown = forwardRef((props: DropdownProps, ref: React.Ref<RefCalback>) => {
  const {
    data,
    editable = true,
    isModalSizeFixed = false,
    value,
    onChange,
    type = EMI.CARDLESS,
    label,
    placeHolder = `Select ${props.label}`,
    getSelectedItemData,
    setSelectedItem: parentSetSelectedItem,
    onClose,
  } = props
  let modifiedValue = value
  if (!modifiedValue) {
    modifiedValue = placeHolder
  }

  const { setEMIPayment, closeModal, updateModalDisplaying, updateCancelModal, theme } = useStores((root) => ({
    setEMIPayment: root.setEMIPayment,
    closeModal: root.config.closeModal,
    updateModalDisplaying: root.config.updateModalDisplaying,
    updateCancelModal: root.config.updateCancelModal,
    theme: root?.config?.merchantTheme,
  }))

  const [open, setOpen] = useState(true)
  const [searchText, setSearchText] = useState('')

  const handleOpen = useCallback(
    (isOpen: boolean) => {
      // If the list length is more than zero then only will show modail
      if (data.length > 0) {
        updateModalDisplaying(isOpen)
        setOpen(isOpen)
      }
    },
    [data.length, updateModalDisplaying],
  )

  useEffect(() => {
    if (closeModal) {
      updateModalDisplaying(false)
      setOpen(false)
      updateCancelModal(false)
    }
  }, [closeModal, updateCancelModal, updateModalDisplaying])

  useImperativeHandle(ref, () => ({
    isEditable: () => {
      return true
    },
    focus: () => handleOpen(true),
  }))

  const [selectedItem, setSelectedItem] = useState('')

  useEffect(() => {
    const currentSelectedItem: any = data.find((item) => item.text === modifiedValue)
    if (currentSelectedItem && currentSelectedItem?.id !== selectedItem) {
      setSelectedItem(currentSelectedItem.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modifiedValue])

  const onHandlePress = (item: DropDownData) => {
    console.log('onHandlePress', item)
    if (onChange) {
      parentSetSelectedItem(item?.id ?? '')
      setSelectedItem(item?.id ?? '')
      onChange(item?.text ?? '')
    }
    setEMIPayment(item?.id, type)
    handleOpen(false)
    if (getSelectedItemData && item) {
      getSelectedItemData(item)
    }
  }

  const getListData = () => {
    const searchfn = (item: DropDownData) => {
      const search = searchText.toLowerCase()
      const text = item?.text?.toLowerCase() ?? ''
      return text.includes(search)
    }
    const listData = data.filter(searchfn)
    return listData
  }

  const onChangeText = (text: string) => {
    setSearchText(text)
  }

  const renderItem = ({ item, index }: { item: any; index: any }) => {
    return (
      <ListItem
        item={item}
        onPress={onHandlePress}
        index={index}
        selectedItem={selectedItem === item?.id}
        theme={theme}
      />
    )
  }

  const renderEmptyView = () => {
    return (
      <Box {...styles.emptyContainer}>
        <Text color={theme.bodyTextColor as ColorOptions} fontFamily="jioType-medium">
          Search not found
        </Text>
      </Box>
    )
  }
  const getSeperator = () => {
    return null
  }

  const onDismiss = () => {
    handleOpen(false)
    onClose()
    setSearchText('')
  }

  return (
    <Box
      onPress={() => {
        if (editable) {
          handleOpen(true)
        }
      }}
      underlayColor={'TRANSPARENT'}
      width={'100%'}
      pointerEvents={Platform.OS === 'web' ? 'box-only' : 'auto'}
      testID={'dropdownId'}>
      <Modal
        type={'BottomTop'}
        title={label ?? ''}
        headerType={theme.bodyBgColor}
        show={open}
        onDismiss={onDismiss}
        theme={theme}
        containerTopPadding={isIE() ? 5 : undefined}>
        <Box
          paddingVertical={8}
          paddingLeft={8}
          width={undefined}
          bg={theme?.bodyBgColor as ColorOptions} //"WHITE"
          {...(isModalSizeFixed ? styles.boxContainer : { maxHeight: '80%', bottom: 2 })}>
          <Spacer size={8} />
          <Box paddingHorizontal={8}>
            <SearchBar
              hide={data.length <= MIN_DATA_TO_SHOW}
              onChange={onChangeText}
              placeholder="Search using name"
              value={searchText}
              autoFocus={open}
              theme={theme}
            />
          </Box>
          <ScrollWrapperIE>
            <Box paddingVertical={8} flex={1}>
              <CustomRecyclerView
                nativeID={'showListScrollBar'}
                keyboardShouldPersistTaps="always"
                keyboardDismissMode="on-drag"
                data={getListData()}
                keyExtractor={(_, index) => index.toString()}
                renderItem={renderItem}
                ListEmptyComponent={renderEmptyView}
                ItemSeparatorComponent={getSeperator}
              />
            </Box>
          </ScrollWrapperIE>
        </Box>
      </Modal>
    </Box>
  )
})

const styles = {
  container: {
    flexDirection: 'row',
    // paddingVertical: 8,
    paddingHorizontal: 16,
    alignItems: 'center',
  } as BoxProps,
  boxContainer: {
    height: '90vh',
    // width: ['80vw', '80vw'],
  } as BoxProps,
  emptyContainer: {
    height: '70vh',
    wight: '50vw',
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  imageView: {
    height: 32,
    width: 32,
  } as ImageProps,
  separatorStyle: (theme: any) =>
    ({ height: 1, backgroundColor: convertHexToRGBA(theme?.brandColor, 10) as ColorOptions } as BoxProps),
}
